import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, useToast } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

import { AutoComplete, DatePickerInput, TextInput, Title, } from "../../../Components/Atoms";

import { PAYMENT_MODE_VALUES } from "../../../Library/constants";
import { StoreContext } from "../../../Library/contexts";

import { addPaymentForLeaseVeh } from "../../../APIs";

import "./style.css";
import { TickIcon } from "../../../Assets/images/svgs"

const FIELD_TYPE = {
  TEXT: 1,
  DATEPICKER: 2,
  AUTOCOMPLETE: 3,
};

const PAYMENT_MODES = [
  { label: "Cash", value: 1 },
  { label: "UPI", value: 2 },
  { label: "Cheque", value: 3 },
  { label: "Bank Transfer", value: 4 },
];

const AddPayment = ({ isOpen = false, closeHandler = () => { }, handleAdd, clientDrivers = [], isOrdersAddPayment = false, isUploadImageVisible = false, orderId, formClass, handleApiSubmission = true }) => {
  const { filters } = useContext(StoreContext)

  const [addModelFormFields, setAddModelFormFields] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const [isUploadImgVisible, setIsUploadImgVisible] = useState(false);
  const [showFileUploadErr, setShowFileUploadErr] = useState(false);

  const [initialPmt, setInitialPmt] = useState(PAYMENT_MODE_VALUES.CASH)

  const [selectedDriver, setSelectedDriver] = useState(0);

  const fileInputRef = useRef(null);

  const location = useLocation();
  const toast = useToast();

  const getFormFields = useCallback((formData = {}) => {
    const formFieldData = [
      {
        type: FIELD_TYPE.TEXT,
        label: "Amount Received",
        name: "amt",
        placeholder: "Enter amount",
      },
      {
        type: FIELD_TYPE.DATEPICKER,
        label: "Receive date",
        name: "ts",
      },
      {
        type: FIELD_TYPE.AUTOCOMPLETE,
        label: "Payment Method",
        name: "pmtMode",
        options: PAYMENT_MODES,
        default: initialPmt
      },
    ];
    if (initialPmt !== PAYMENT_MODE_VALUES.CASH) formFieldData.push({
      type: FIELD_TYPE.TEXT,
      label: "Reference No.",
      name: "refNo",
      placeholder: "Enter Reference Numer",
    });

    formFieldData.push({
      type: FIELD_TYPE.AUTOCOMPLETE,
      label: "Driver Name",
      name: "drId",
      placeholder: "Enter Driver Name",
      options: clientDrivers,
      isDriverInput: true,
      isSearchable: true,
    });
    return formFieldData;
  }, [initialPmt, clientDrivers]);

  const orderAddPaymentFormFields = useCallback(() => {
    return [
      {
        type: FIELD_TYPE.TEXT,
        label: "Transaction ID",
        name: "refNo",
        placeholder: "Enter Transaction ID",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Amount Paid",
        name: "amt",
        placeholder: "₹50000",
      },
      {
        type: FIELD_TYPE.DATEPICKER,
        label: "Payment Date",
        name: "ts",
      },
    ];
  }, []);

  const modalCloseHandler = (e) => {
    if (e)
      for (const input of Array.from(e.target)) {
        input.value = ""
      }

    setInitialPmt(PAYMENT_MODE_VALUES.CASH);
    setShowFileUploadErr(false);
    setIsUploadImgVisible(false);
    setSelectedFile(null);
    closeHandler();
  }

  const postPaymentHandler = async (data, e) => {
    data["clientId"] = filters.client;
    data["pmtMode"] = initialPmt;
    data["ts"] = Date.parse(data["ts"]);
    data["drId"] = Number(selectedDriver);

    if (handleApiSubmission) {
      addPaymentForLeaseVeh(data, selectedFile ? [selectedFile] : [])
        .then((resp) => {
          if (resp) {
            toast({
              title: 'Payment successfully added',
              description: "Payment successfully added for lease vehicle",
              status: 'success',
              duration: 9000,
              isClosable: true,
            })

            handleAdd(resp);
            modalCloseHandler(e);
          }
        })
        .catch((err) => {
          toast({
            title: 'Payment failed.',
            description: err || "Something went wrong",
            status: 'error',
            duration: 9000,
            isClosable: true,
          })
        });
    } else {
      handleAdd(data, selectedFile);
      modalCloseHandler(e);
    }
  }

  const saveHandler = (e) => {
    e.preventDefault();
    const formData = {};

    let errorInputIndex = addModelFormFields.findIndex((field) => field.errMessage);

    if (errorInputIndex !== -1) {
      delete addModelFormFields[errorInputIndex].errMessage;
      setAddModelFormFields([...addModelFormFields]);
    }

    for (const input of Array.from(e.target)) {
      if (input.tagName === "INPUT") {
        if (input.name === "refNo" && [PAYMENT_MODE_VALUES.CASH].includes(initialPmt)) {
          formData[input.name] = input.value;
        }
        else if (!input.value || (input.name === "amt" && !input.value.match(/^[0-9]+$/))) {
          const index = addModelFormFields.findIndex((field) => {
            return field.name === input.name;
          });

          if (index >= 0) {
            addModelFormFields[index] = {
              ...addModelFormFields[index],
              errMessage: `Please enter ${addModelFormFields[index].label}`,
            };
            setAddModelFormFields([...addModelFormFields]);
            return;
          }
        }

        formData[input.name] = input.value;
      }
    }

    if (isUploadImgVisible && !selectedFile) {
      setShowFileUploadErr(true);
      return;
    }

    postPaymentHandler(formData, e);

  };

  const handleFileUpload = (e) => {
    setSelectedFile(e.target.files[0]);
    if (selectedFile) setShowFileUploadErr(false);
  }

  useEffect(() => {
    if (isOrdersAddPayment) {
      setAddModelFormFields(orderAddPaymentFormFields());
    }
    else if (location.state && location.state.model) {
      setAddModelFormFields(getFormFields(location.state.model));
    } else setAddModelFormFields(getFormFields());
  }, [location, isOrdersAddPayment, orderAddPaymentFormFields]);

  const autoCompleteHandler = (value, isDriverSelection) => {
    if (isDriverSelection) {
      setSelectedDriver(value)
    } else {
      if ([PAYMENT_MODE_VALUES.UPI, PAYMENT_MODE_VALUES.BANK_TRANSFER].includes(Number(value)))
        setIsUploadImgVisible(true);
      else {
        setIsUploadImgVisible(false);
        setShowFileUploadErr(false);
      }

      setInitialPmt(Number(value));
    }
  }

  const ordersAddPaymentPostHandler = (data, e) => {
    data["orderId"] = orderId;
    data["ts"] = Date.parse(data["ts"]);

    if (handleApiSubmission) {
      addPaymentForLeaseVeh(data, selectedFile ? [selectedFile] : [])
        .then((resp) => {
          if (resp) {
            toast({
              title: 'Payment successfully added',
              description: "Payment successfully added for orders",
              status: 'success',
              duration: 9000,
              isClosable: true,
            })

            handleAdd(resp);
            modalCloseHandler(e);
          }
        })
        .catch((err) => {
          toast({
            title: 'Payment failed.',
            description: err || "Something went wrong",
            status: 'error',
            duration: 9000,
            isClosable: true,
          })
        });
    } else {
      handleAdd(data, selectedFile);
      modalCloseHandler(e);
    }
  }

  const ordersAddPaymentHandler = (e) => {
    e.preventDefault();
    const formData = {};

    let errorInputIndex = addModelFormFields.findIndex((field) => field.errMessage);

    if (errorInputIndex !== -1) {
      delete addModelFormFields[errorInputIndex].errMessage;
      setAddModelFormFields([...addModelFormFields]);
    }

    for (const input of Array.from(e.target)) {
      if (input.tagName === "INPUT") {
        if (!input.value || (input.name === "amt" && !input.value.match(/^[0-9]+$/))) {
          const index = addModelFormFields.findIndex((field) => {
            return field.name === input.name;
          });

          if (index >= 0) {
            addModelFormFields[index] = {
              ...addModelFormFields[index],
              errMessage: `Please enter ${addModelFormFields[index].label}`,
            };
            setAddModelFormFields([...addModelFormFields]);
            return;
          }
        }

        formData[input.name] = input.value;
      }
    }


    if (isUploadImageVisible && !selectedFile) {
      setShowFileUploadErr(true);
      return;
    }

    ordersAddPaymentPostHandler(formData, e);
  }

  return (
    <Modal size={''} isOpen={isOpen} onClose={modalCloseHandler} isCentered={true}>
      <ModalOverlay />

      <ModalContent boxSize={'3xl'} height={'initial'} className='custom-modal-content' >
        <ModalHeader>
          {isOrdersAddPayment ? <Title>Payment Details</Title> : <Title>Add Payment</Title>}
        </ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <form className={`payment-model-form ${formClass || ""}`} onSubmit={isOrdersAddPayment ? ordersAddPaymentHandler : saveHandler}>
            {addModelFormFields.map((formField, idx) => {
              return (
                <React.Fragment key={idx}>
                  {formField.type === FIELD_TYPE.TEXT && (
                    <div key={idx} className={`payment-modal-text-field-group`}>
                      <TextInput
                        inputName={formField.name || ""}
                        placeholder={formField.placeholder || ""}
                        className="payment-modal-text-field"
                        label={formField.label}
                        labelClassName={`payment-modal-text-field-label ${formField.labelClass}`}
                        inputCover={"payment-modal-text-input-cover"}
                        errMessage={formField.errMessage || ""}
                      />
                    </div>
                  )}

                  {formField.type === FIELD_TYPE.AUTOCOMPLETE && (
                    <>
                      <div className={`payment-modal-autocomplete-field-group`}>
                        {
                          <AutoComplete
                            options={formField.options}
                            placeholder={"Select"}
                            inputName={formField.name || ""}
                            label={formField.label}
                            labelClassName="payment-modal-autocomplete-field-label"
                            errMessage={formField.errMessage || ""}
                            autoCompleteClassName={"payment-modal-autocomplete"}
                            inputCover={"payment-modal-autocomplete-input-cover"}
                            isSearchable={formField.isSearchable || false}
                            onChange={(value) => autoCompleteHandler(value, formField.isDriverInput)}
                            value={formField.default || ""}
                          />
                        }
                      </div>
                    </>
                  )}

                  {formField.type === FIELD_TYPE.DATEPICKER && (
                    <div className={`payment-modal-datepicker-field-group`}>
                      {
                        <DatePickerInput
                          onChange={() => { }}
                          inputName={formField.name || ""}
                          label={formField.label}
                          labelClassName="payment-modal-datepicker-field-label"
                          DatepickerClassName={"payment-modal-datepicker"}
                          inputCover={"payment-modal-datepicker-input-cover"}
                          errMessage={formField.errMessage || ""}
                        />
                      }
                    </div>
                  )}
                </React.Fragment>
              );
            })}

            <div className="add-payment-footer">
              <div>
                {(isUploadImgVisible || isUploadImageVisible) && <p onClick={() => fileInputRef.current.click()} className="upload-ss-btn">
                  {selectedFile ? "Change Image" : "Upload Screenshot"} {selectedFile && <TickIcon />}
                </p>}

                {(!selectedFile && showFileUploadErr) ? <p className="upload-ss-err-msg-text">File not selected yet</p> : null}

                <input
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                  onChange={handleFileUpload}
                  name="image"
                />
              </div>

              <Button type="submit" className={"add-payment-button"}>
                Save
              </Button>
            </div>
          </form>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AddPayment;
